<template lang="html">
  <section class="s-gallery">
      <h4>Gallery</h4>
      <ul class="cs__gallery">
        <li v-for="image in images"
          :key="image.id"
          @click="lightbox(image.id)"
        >
          <img :src="image.image" v-bind:alt="['Gallery Image ' + image.id]">
          <div class="cs__gallery-img">
            <div>
              <img src="/static/svg/eye.svg" alt="">
            </div>
          </div>
          <div class="cs__lightbox-bg"
              v-if="isActive === image.id"
              @click.stop="isActive = false"
          >
            <div class="cs__lightbox">
              <img
                :src="image.image"
                v-bind:alt="['Gallery Image ' + image.id]"
                @click.stop="isActive = false">
            </div>
          </div>
        </li>
      </ul>
    </section>
</template>

<script>
  export default {
    name: 'cs-gallery',
    data () {
      return {
        isActive: false,
        images: [
          {
            id: 1,
            image: 'https://fillmurray.com/300/400'
          },
          {
            id: 2,
            image: 'https://fillmurray.com/400/400'
          },
          {
            id: 3,
            image: 'https://fillmurray.com/500/400'
          },
          {
            id: 4,
            image: 'https://fillmurray.com/600/400'
          },
          {
            id: 5,
            image: 'https://fillmurray.com/700/400'
          },
          {
            id: 6,
            image: 'https://fillmurray.com/800/400'
          },
          {
            id: 7,
            image: 'https://fillmurray.com/500/400'
          },
          {
            id: 8,
            image: 'https://fillmurray.com/500/400'
          },
          {
            id: 9,
            image: 'https://fillmurray.com/500/400'
          },
          {
            id: 10,
            image: 'https://fillmurray.com/500/400'
          },
          {
            id: 11,
            image: 'https://fillmurray.com/500/400'
          },
          {
            id: 12,
            image: 'https://fillmurray.com/500/400'
          }
        ]
      }
    },
    methods: {
      lightbox (id) {
        this.isActive = id
      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .s-gallery {
    grid-column: 2 / 5;
    grid-row: 3 / 4;
    z-index: 10;
    h4 {
      font-family: $barlowCondensed;
      font-size: 1.875rem;
      font-weight: 700;
      color: $dark-blue;
    }
  }

  .cs__gallery {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(18.687rem, 1fr));
    grid-auto-rows: minmax(auto, 18.687rem);
    grid-gap: 0.063rem;
    list-style-type: none;
    margin: 0;
    padding: 0;
    background-color: $white;
    padding: 1rem 1rem 1rem 0;
    > li {
      position: relative;
      overflow: hidden;
      &:hover {
        > img {
          transform: scale(1.1);
        }
      }
      > img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        object-fit: cover;
        object-position: 50% 50%;
        transition: 0.3s ease;
      }
    }
  }

  .cs__gallery-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.5rem;
    color: $white;
    transition: background 0.3s ease;
    &:hover {
      background-color: rgba($dark-red, 0.5);
      cursor: pointer;
      > div {
        display: flex;
      }
    }
    > div {
      display: none;
      justify-content: center;
      align-items: center;
      border: 1px solid $white;
      border-radius: 100%;
      height: 5.625rem;
      width: 5.625rem;
    }
  }

  .cs__lightbox {
    position: relative;
    max-width: 40rem;
    margin: 0 1rem;
    // box-shadow: 0px 3px 25px 5px rgba($black, 0.3);
    img {
      width: 100%;
      vertical-align: middle;
      height: auto;
    }
  }

  .cs__lightbox-bg {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba($dark-blue, 0.9);
    z-index: 100;
  }

</style>



// WEBPACK FOOTER //
// src/components/CsGallery.vue